import { useEffect } from 'react';

const BotpressChat = () => {
  useEffect(() => {
    const injectScript = document.createElement('script');
    injectScript.src = 'https://cdn.botpress.cloud/webchat/v3.5/inject.js';
    injectScript.async = true;

    injectScript.onload = () => {
      const configScript = document.createElement('script');
      configScript.src = 'https://files.bpcontent.cloud/2026/02/01/12/20260201123513-L4O3NUAU.js';
      document.body.appendChild(configScript);
    };

    document.body.appendChild(injectScript);

    return () => {
      document.querySelectorAll(
        'script[src*="cdn.botpress.cloud"], script[src*="files.bpcontent.cloud"]'
      ).forEach((s) => s.remove());
    };
  }, []);

  return null;
};

export default BotpressChat;
